import { FC, lazy, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { data } from "@/mock/menu";
import { useRoutes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store";
import { changeMenus } from "@/store/redux/userSlice";

const Login = lazy(() => import("@/views/login"));
const NoFound = lazy(() => import("@/views/noFound"));
// 快速导入工具函数
const lazyLoad = (moduleName: string) => {
  const Module: any = lazy(() => import(`@/components/${moduleName}`));
  return <Module />;
};
const Appraisal = ({ children }: any) => {
  const token = localStorage.getItem("token");
  // return token ? children : children;
  return token ? children : <Navigate to="/login" />;
};
export const defaulyRoutes: any = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <Appraisal>{lazyLoad("layout")}</Appraisal>,
    children: [
      {
        path: "*",
        element: lazyLoad("noPermission"),
      },
    ],
  },
  {
    path: "*",
    element: <NoFound />,
  },
];
// 权限列表 和 导航菜单 得出路由表 element暂用字符串表示 后面渲染前再映射
export const handelFilterRouter = (menus: any, routes: any = []) => {
  for (const menu of menus) {
    if (menu.is_display === 1) {
      const obj = {
        path: menu.url_sign,
        element: lazyLoad(SetUp(menu?.path)),
        children: menu?.child?.length ? handelFilterRouter(menu.child) : [],
      };
      routes.push(obj);
    }
  }
  return routes;
};
// 返回最终路由表
export const handelEnd = (routes: any) => {
  defaulyRoutes[1].children = [...routes, ...defaulyRoutes[1].children];
  return defaulyRoutes;
};
// 映射element 成对应组件
export const handelFilterElement = (routes: any) => {
  return routes.map((route: any) => {
    route.element = lazyLoad(route.element);
    return route;
  });
};

const SetUp = (str: string) => {
  if (str?.includes("_")) {
    return str.replace(/_([a-z])/g, function (match, group1) {
      return group1.toUpperCase();
    });
  } else {
    return str;
  }
};

export const handelFilterRouters = (menus: any, routes: any = []) => {
  for (const menu of menus) {
    if (menu.is_display === 1) {
      const arr: any = {
        path: menu.url_sign,
        element: menu.path,
        name: menu?.name,
        children: menu?.child?.length ? handelFilterRouters(menu.child) : [],
      };
      routes.push(arr);
    }
  }
  return routes;
};

interface AdminProps {}
export const AdminRouter: FC<AdminProps> = () => {
  const menus = useSelector((state: RootState) => state.userSlice.menus);
  const [routes, setRoutes] = useState<any>(defaulyRoutes);
  const element: any = useRoutes(routes);
  const dispatch = useDispatch();

  // 判断浏览器是否在刷新或页面关闭
  useEffect(() => {
    if (window?.location.pathname !== "/login") {
      // dispatch(GetMeus());
      dispatch(changeMenus(data));
    }
  }, []);
  useEffect(() => {
    setRoutes(handelEnd(handelFilterRouter(menus)));
    console.log("test===", menus, handelFilterRouter(menus));
  }, [menus]);
  return <div>{element}</div>;
};
